import { andJoin, createLabeledMessages } from '../../../messageUtils';
const policy = {
    duration: 'trvanie poistenia',
    paymentFrequency: 'frekvencia platenia',
    insuranceStart: 'začiatok poistenia',
    insuranceStartTime: 'čas začiatku poistenia',
    insuranceEnd: 'koniec poistenia',
    agreementDate: 'dátum uzatvorenia',
    dayCount: 'počet dní',
    paymentPerYear: 'ročné poistné celkom',
    paymentValue: 'výška splátky',
    paymentType: 'spôsob platby',
    creation: 'vznik poistnej zmluvy',
    specialAgreement: 'špeciálne dojednania',
    note: 'poznámka k zmluve',
    paceAndDate: andJoin('address:place_label', 'policy:agreementDate'),
    insuranceType: 'typ poistenia'
};
export default Object.assign({}, policy, createLabeledMessages(policy));
